export enum LLMReasoningEffort {
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high'
}